<div class="p-card">
  <div class="p-card-header">
      Consejos útiles
  </div>
  <div class="p-card-body p-p-0">
    <ul>
      <li>Si una postulación está pendiente de pago o en revisión, te avisaremos por correo cuando ya puedas ingresar.</li>
      <li>Si un curso ya no se encuentra disponible, es posible que no puedas revisar los contenidos.</li>
      <li>Recuerda que para obtener tu certificado deberás aprobar los cursos que realices.</li>
    </ul>
  </div>
  <div class="p-card-footer">
    <img width="100%" src="assets/images/consejos_utiles.svg">
  </div>
</div>

